import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import WebPage from "./neonimble/webpage/WebPage";
import PrivacyPolicy from "./neonimble/webpage/components/privacy/PrivacyPolicy";
import DeleteAccount from "./neonimble/webpage/components/account/DeleteAccount";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WebPage />} />
        <Route path="/web" element={<WebPage />} />
        <Route path="/web/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/web/delete-account" element={<DeleteAccount />} />
        <Route path="*" element={<WebPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
